<template>
  <div
    class="flex h-full w-full flex-grow flex-col justify-between space-y-4 rounded-lg bg-ontick-steel-100 px-4 py-6 dark:bg-ontick-graphite-500 dark:shadow-xl"
  >
    <span
      class="text-sm font-bold text-ontick-carbon-900 dark:text-gray-400 xs:text-base"
      >Alocação</span
    >
    <div
      class="flex flex-col items-start divide-ontick-steel-400 dark:divide-ontick-steel-500 xs:flex-row xs:divide-x"
    >
      <div
        class="flex items-center divide-ontick-steel-400 dark:divide-ontick-steel-500 xs:divide-x"
      >
        <div class="flex flex-col pr-2">
          <span class="number">999</span>
          <span class="description">Minicontratos</span>
        </div>
        <div class="flex flex-col px-2">
          <span class="number">999</span>
          <span class="description">Contratos</span>
        </div>
      </div>
      <div class="flex flex-col pt-2 xs:pt-0 xs:pl-2">
        <span class="number">{{ 999999 | currency }}</span>
        <span class="description">Ações</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.number {
  @apply whitespace-nowrap text-lg font-bold text-ontick-carbon-900 dark:text-gray-200 sm:text-xl;
}
.description {
  @apply text-xs text-ontick-steel-400 dark:text-gray-500;
}
</style>
